import { MobileOS } from 'listing-details/types';
import { DFP_AD_UNIT } from 'shared/components/Adverts/types';

export const getMobileOS = (userAgent: string): MobileOS => {
    // https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system
    if (/android/i.test(userAgent)) {
        return 'android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'ios';
    }

    return null;
};

// TODO: this should be refactored as part of https://zpgltd.atlassian.net/browse/AF-884
export const getAdUnitCode = (isMobile: boolean, section: string) => {
    if (section === 'to-rent') {
        return isMobile
            ? DFP_AD_UNIT.ZOOPLA_LDP_TO_RENT_MOBILE
            : DFP_AD_UNIT.ZOOPLA_LDP_TO_RENT_DESKTOP;
    } else if (section === 'new-homes') {
        return isMobile
            ? DFP_AD_UNIT.ZOOPLA_LDP_NEW_HOMES_MOBILE
            : DFP_AD_UNIT.ZOOPLA_LDP_NEW_HOMES_DESKTOP;
    } else if (section === 'overseas') {
        return isMobile
            ? DFP_AD_UNIT.ZOOPLA_LDP_OVERSEAS_MOBILE
            : DFP_AD_UNIT.ZOOPLA_LDP_OVERSEAS_DESKTOP;
    } else {
        return isMobile
            ? DFP_AD_UNIT.ZOOPLA_LDP_FOR_SALE_MOBILE
            : DFP_AD_UNIT.ZOOPLA_LDP_FOR_SALE_DESKTOP;
    }
};
